import { Link } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../assets/svg/icons/back.svg";
import { ReactComponent as PastejoIcon } from "../../../assets/svg/logo/iconV2.svg";

export function PolicyHeader() {
  return (
    <header className="home-page-v2__policy-header">
      <div className="home-page-v2__section-inner home-page-v2__policy-header-inner">
        <Link
          className="home-page-v2__policy-home-link"
          to="/"
          aria-label="Voltar para a página inicial"
        >
          <BackIcon aria-hidden="true" />
          <span>Voltar para a página inicial</span>
        </Link>

        <Link to="/" aria-label="Pastejo — página inicial">
          <PastejoIcon className="home-page-v2__policy-logo" />
        </Link>
      </div>
    </header>
  );
}
